import { DropdownOptionModel } from './dropdown-option-model';
import { PropertyRequest } from '../shared/models';
import ManufacturedHomeOwnership = PropertyRequest.ManufacturedHomeOwnershipEnum;

export const MANUFACTURED_HOME_OWNERSHIP_OPTIONS: DropdownOptionModel<ManufacturedHomeOwnership>[] = [
  { value: ManufacturedHomeOwnership.DirectOwnership, display: 'Direct Ownership' },
  { value: ManufacturedHomeOwnership.IndirectOwnership, display: 'Indirect Ownership' },
  { value: ManufacturedHomeOwnership.PaidLeasehold, display: 'Paid Leasehold' },
  { value: ManufacturedHomeOwnership.UnpaidLeashold, display: 'Unpaid Leasehold' }
];
